import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedContract, clearValidationError } from '../../../../../services/ContractService/contractSlice';
import { useGetCalcTypesQuery } from '../../../../../services/ContractService';

const CalcTypeEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const validationErrors = useAppSelector((state) => state.contract.validationErrors);
  const { data: calcTypes = [] } = useGetCalcTypesQuery();

  const handleChange = (value: string) => {
    if (contract) {
      dispatch(updateSelectedContract({ calcType: value }));
      if (validationErrors.calcType) {
        dispatch(clearValidationError('calcType'));
      }
    }
  };

  if (!contract) return null;

  return (
    <FormControl variant="outlined" size="small" error={!!validationErrors.calcType} sx={{ width: 220 }}>
      <InputLabel>Calc Type *</InputLabel>
      <Select
        value={contract.calcType}
        onChange={(e) => handleChange(e.target.value)}
        label="Calc Type *"
        sx={{ backgroundColor: 'white' }}
      >
        {calcTypes.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
      {validationErrors.calcType && (
        <FormHelperText>{validationErrors.calcType}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CalcTypeEditor;
